import React from 'react';
import styled from 'styled-components';

import { EmptyStateWrapper } from 'src/presentation/components/pages/shared/Table';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import Jetplane from 'src/images/Jetplane.svg';
import { Row } from 'src/presentation/components/forms/Layout';

const EmptyState = ({ title, actionsRender }) => (
  <StyledEmptyStateWrapper data-aid="emptyMessage">
    <img src={Jetplane} />
    <StyledH3>{title}</StyledH3>
    <Row>{actionsRender}</Row>
  </StyledEmptyStateWrapper>
);

const StyledEmptyStateWrapper = styled(EmptyStateWrapper)`
  flex: 1;
`;

const StyledH3 = styled(H3)`
  margin: 26px 0 16px 0;
`;

export default EmptyState;
